import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import ProductGrid from '../../components/storefront/product/ProductGrid.jsx';
import Seo from '../../components/common/Seo.jsx';
import { storefrontService } from '../../services/storefrontService.js';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [payload, setPayload] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setStatus('loading');
    storefrontService.products({ search: query }).then((data) => {
      if (!active) return;
      setPayload(data);
      setStatus('ready');
    });
    return () => {
      active = false;
    };
  }, [query]);

  if (status === 'loading') return <LoadingState label="Searching products" />;

  return (
    <>
      <Seo title={`Search: ${query}`} path="/search" noindex />
      <PageHero
        eyebrow="Search"
        title={`Results for “${query}”`}
        text={`${payload.products.length} product${payload.products.length === 1 ? '' : 's'} found`}
        image="assets/uploads/banner_search.png"
      />
      <section className="container page-section">
        <ProductGrid products={payload.products} emptyTitle="No matching products" />
      </section>
    </>
  );
}
